import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, from, mergeMap, Observable } from 'rxjs';
import { TokenStorageService } from "../auth/token-storage.service";
import { environment } from "../../../environments/environment";
import { KeycloakSessionService } from "../auth/keycloak-session.service";

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private readonly tokenStorage: TokenStorageService,
    private readonly router: Router,
    private readonly keycloakSession: KeycloakSessionService
  ) {}

  intercept = (request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> => {

    if(environment.UNSECURE) {
      return next.handle(request);
    }

    return from(this.prepareRequest(request)).pipe(
      mergeMap(preparedRequest => preparedRequest ? next.handle(preparedRequest) : EMPTY)
    );
  }

  private async prepareRequest(request: HttpRequest<any>): Promise<HttpRequest<any> | null> {
    const hasStoredToken = !!this.tokenStorage.getToken();

    if (!hasStoredToken) {
      console.debug('[AuthInterceptor] No token — request sent without Authorization header:', request.url);
      return request;
    }

    const token = await this.keycloakSession.getValidToken(30, `Before request: ${request.url}`);
    if (!token) {
      console.debug('[AuthInterceptor] Token expired — clearing session and redirecting to login');
      this.keycloakSession.clearSession();
      await this.router.navigate(['login']);
      return null;
    }

    console.debug('[AuthInterceptor] Using valid token for request:', request.url);

    if (request.url === environment.KEYCLOAK_TOKEN_URL) {
      return request;
    }

    return request.clone({
      headers: request.headers.set(TOKEN_HEADER_KEY, `Bearer ${token}`)
    });
  }
}
